import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useRef } from "react";
import { Form } from "reactstrap";
import { COLOR_PRIMARY } from "../../../constants/theme";
import { InputWembii } from "../InputWembii";
import { useIntl } from "react-intl";
import "emoji-mart/css/emoji-mart.css";
import { EmojiForm } from "../EmojiForm";

interface Props {
  onSubmit: (text: string) => void;
  disabled?: boolean;
}

export default function SubmitInput(props: Props) {
  const intl = useIntl();
  const { onSubmit, disabled = false } = props;
  const [text, setText] = useState("");
  const [showPicker, setShowPicker] = useState(false);

  const onFormSubmit = (e?: any) => {
    if (e) e.preventDefault();

    if (!disabled) {
      const trimmedText = text.trim();
      onSubmit(trimmedText);
      setText("");
    }
  };



 

  return (
    <Form onSubmit={onFormSubmit}>
      <InputWembii
        type="text"
        disabled={disabled}
        placeholder={intl.formatMessage({ id: "app.chatFacebook.writeMsg" })}
        rounded
        className="mt-1"
        value={text}
        mb={false}
        onChange={(v) => setText(v)}
        icon={
          <div className="flex h-100 justify-content-center align-items-center p-2">
            <FontAwesomeIcon
              icon={["far", "smile"]}
              size="1x"
              color={disabled ? "gray" : COLOR_PRIMARY}
              className="m-1 pointer z-index-50"
              onClick={() => setShowPicker(!showPicker)}
            />
            <FontAwesomeIcon
              icon={["far", "paper-plane"]}
              size="1x"
              color={disabled ? "gray" : COLOR_PRIMARY}
              className="m-1 pointer z-index-50"
              onClick={onFormSubmit}
            />
          </div>
        }
      />

      {showPicker && (
        <div>
          <div>
            <EmojiForm
              onAdding={(emoji: any) => setText(`${text} ${emoji.native}`)}
            />
          </div>
        </div>
      )}
    </Form>
  );
}
